
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'About', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Process', href: '/process' },
  { label: 'Our Work', href: '/portfolio' },
  { label: 'Industries', href: '/industries' },
  { label: 'Partnership', href: '/partnership' },
  { label: 'Contact', href: '/contact' },
];

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-zinc-950 shadow-lg shadow-black/20' : 'bg-zinc-950'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/51b92d7fefcf4905c242441f3c7dddfe/fca0ce1bda8298b6a686d97531ce5f08.png"
              alt="ZJF IT Services Logo"
              className="h-11 w-11 object-contain"
            />
            <span className="text-lg font-semibold text-white tracking-tight whitespace-nowrap">
              ZJF IT Services LLC
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href ? 'text-orange-500' : 'text-gray-300 hover:text-orange-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:973-750-4968"
              className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded-md text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-base"></i>
              973-750-4968
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden flex items-center justify-center w-10 h-10 text-white cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-zinc-950/95 backdrop-blur-sm border-t border-zinc-800">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm font-medium py-3 px-3 rounded-md transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-orange-500 bg-zinc-800/50'
                    : 'text-gray-300 hover:text-orange-500 hover:bg-zinc-800/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:973-750-4968"
              className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-5 py-3 rounded-md text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer mt-2"
            >
              <i className="ri-phone-line text-base"></i>
              973-750-4968
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
